export const downloadObject = (object, fileName) => {
  const jsonString = JSON.stringify(object, null, 2);
  const blob = new Blob([jsonString], { type: 'application/json' });
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement('a');
  anchor.href = url;
  anchor.download = fileName;
  document.body.appendChild(anchor);
  anchor.click();
  document.body.removeChild(anchor);
  URL.revokeObjectURL(url);
};

const handleFileUpload = (event, saveHandler) => {
  const file = event.target.files[0];
  const reader = new FileReader();
  reader.onload = (e) => {
    const data = JSON.parse(e.target.result);
    saveHandler(data);
    const fileInput = document.getElementById('fileInput');
    document.body.removeChild(fileInput);
  };
  reader.readAsText(file);
};

export const uploadFile = (accept, saveHandler) => {
  const fileInput = document.createElement('input');
  fileInput.id = 'fileInput';
  fileInput.type = 'file';
  fileInput.accept = accept;
  fileInput.style.display = 'none';
  fileInput.addEventListener('change', (e) => handleFileUpload(e, saveHandler), true);
  document.body.appendChild(fileInput);
  fileInput.click();
};
